module.exports = __webpack_public_path__ + "img/profilo3_sendmagic.d8dca320.png";